import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  croschedulesData: [],
  loading: false,
};
// ----------------------------------categorycrud-----------------------------------
export const getCroSchedules = createAsyncThunk(
  "croschedule/allcroschedule",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `cro-schedules`,
    });
    console.log("Get schedules", res);
    return res;
  }
);
export const updateCroSchedules = createAsyncThunk(
  "croschedule/updatecroschedule",
  async () => {
    const res = await apiRequest({
      method: "put",
      url: `cro-schedules`,
    });
    console.log("Get schedules", res);
    return res;
  }
);

const croScheduleSlice = createSlice({
  name: "croschedule",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCroSchedules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCroSchedules.fulfilled, (state, action) => {
      state.loading = false;
      state.croschedulesData = action.payload.data;
    });
    builder.addCase(updateCroSchedules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCroSchedules.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateCroSchedules.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

// export const { apiCallData } = permissionSlice.actions;

export default croScheduleSlice.reducer;
